const t = {
  name: "ChevronRightSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.58564 15.9998L12.5856 11.9998L8.58564 7.99985L9.99985 6.58564L15.4141 11.9998L9.99985 17.4141L8.58564 15.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronRightSmall
};
